// extracted by mini-css-extract-plugin
export default {"userSelect":"styles_userSelect__YNJlE"};